import colors from "../../base/colors";
import typography from "../../base/typography";
export default {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      flex: "0 1 auto",
      minHeight: 44,
      minWidth: 0,
      padding: "12px 16px",
      fontSize: typography.size.sm,
      fontWeight: 500,
      textTransform: "none",
      lineHeight: 1.4,
      color: colors.text.main,
      opacity: 1,
      "&.Mui-selected": { color: colors.dark.main, fontWeight: 650 },
      "&:hover": { backgroundColor: colors.surface.alternate },
      "& svg, & .material-icons, & .material-icons-round": {
        marginBottom: 0,
        marginRight: 8,
        fontSize: 18,
      },
    },
  },
};
